const roles = {
	1:  { description: "Sales Lead", salary: 118000, departmentId: 1},
	2:  { description: "Salesperson", salary: 68000, departmentId: 1},
	3:  { description: "Sales Manager", salary: 118000, departmentId: 1},
	4:  { description: "Lead Engineer", salary: 133000, departmentId: 2},
	5:  { description: "Software Engineer", salary: 110000, departmentId: 2},
	6:  { description: "Engineer Manager", salary: 140000, departmentId: 2},
	7:  { description: "Accountant", salary: 63000, departmentId: 3},
	8:  { description: "Legal Team Lead", salary: 77000, departmentId: 4},
	9:  { description: "Lawyer", salary: 130000, departmentId: 4},
	10: { description: "Account Manager", salary: 120000, departmentId: 5},
	11: { description: "Human Resources Generalist", salary: 69000, departmentId: 6},
	12: { description: "Human Resources Manager", salary: 104000, departmentId: 6},
	13: { description: "Buyer", salary: 56000, departmentId: 7},
	14: { description: "Commodity Manager", salary: 104000, departmentId: 7},
	15: { description: "Social Media Specialist", salary: 82000, departmentId: 8},
	16: { description: "Marketing Manager", salary: 105000, departmentId: 8},
	17: { description: "Assembly Technician", salary: 37000, departmentId: 9},
	18: { description: "Operations Supervisor", salary: 62000, departmentId: 9},
	19: { description: "Quality Control Inspector", salary: 48000, departmentId: 10},
	20: { description: "Quality Assurance Manager", salary: 111000, departmentId: 10},
	21: { description: "CEO", salary: 819000, departmentId: 11},
};
export default roles;
